import { Card, CardContent } from 'components/ui/card';
import { Carousel, CarouselApi, CarouselContent, CarouselDots, CarouselItem } from 'components/ui/carousel';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaQuoteLeft } from 'react-icons/fa6';

/** Ant Design's `Carousel autoplay` advanced every 3s; embla has no built-in autoplay. */
const AUTOPLAY_INTERVAL_MS = 3000;

export default function ExampleQuestions() {
  // Hooks
  const { t } = useTranslation();
  const [api, setApi] = useState<CarouselApi>();

  useEffect(() => {
    if (!api) return;
    const interval = setInterval(() => api.scrollNext(), AUTOPLAY_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [api]);

  const exampleMessages = t<string, { returnObjects: true }, string[]>('chats.new.exampleMessages', {
    returnObjects: true,
  });

  return (
    <div className="mt-2 w-full p-8">
      <Carousel setApi={setApi} opts={{ loop: true }}>
        <CarouselContent>
          {exampleMessages.map((message, index) => (
            <CarouselItem key={`card-${index}`}>
              <Card>
                <CardContent className="flex items-start gap-2">
                  <FaQuoteLeft className="mt-1 shrink-0 text-foreground" />
                  <span>{message}</span>
                </CardContent>
              </Card>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselDots />
      </Carousel>
    </div>
  );
}
